import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=5fffdcd1&scoped=true&"
import script from "./Layout1.vue?vue&type=script&lang=js&"
export * from "./Layout1.vue?vue&type=script&lang=js&"
import style0 from "./Layout1.vue?vue&type=style&index=0&id=5fffdcd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fffdcd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fffdcd1')) {
      api.createRecord('5fffdcd1', component.options)
    } else {
      api.reload('5fffdcd1', component.options)
    }
    module.hot.accept("./Layout1.vue?vue&type=template&id=5fffdcd1&scoped=true&", function () {
      api.rerender('5fffdcd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/layout/Layout1.vue"
export default component.exports